import ColChartAImg from 'assets/images/base-widgets/column-chart-a-CR04.png';
import ColChartBImg from 'assets/images/base-widgets/column-chart-b-CR05.png';
import CustomTableC from 'assets/images/base-widgets/custom-table-c-TR10.png';
import CustomTableD from 'assets/images/base-widgets/custom-table-d-TR11.png';
import LineGraphA from 'assets/images/base-widgets/line-graph-a-LR05.png';
import LineGraphASecondY from 'assets/images/base-widgets/line-graph-a-second-y-LR05.png';
import LineGraphB from 'assets/images/base-widgets/line-graph-b-LR06.png';
import PortfolioManagers from 'assets/images/base-widgets/portfolio-managers.png';
import StackedColB from 'assets/images/base-widgets/stacked-column-chart-b-CR07.png';
import StrExposure from 'assets/images/base-widgets/strategy-exposure.png';
import SubStrExposure from 'assets/images/base-widgets/sub-strategy-exposure.png';
import ObjectMap from 'assets/images/base-widgets/object-map.png';
import Performance from 'assets/images/base-widgets/performance.png';
import BarChartImage from 'assets/images/base-widgets/bar-chart.png';
import ComparitiveStatsImage from 'assets/images/base-widgets/comparitive-stats.png';
import DocumentsImage from 'assets/images/base-widgets/documents.png';
import NotesImage from 'assets/images/base-widgets/notes.png';
import TableAImg from 'assets/images/base-widgets/table-a.png';
import CumulativeImg from 'assets/images/base-widgets/cumulative.png';
import ScatterImg from 'assets/images/base-widgets/scatter.png';
import DiversificationImage from 'assets/images/base-widgets/diversification.png';
import AreaColumnChart from 'assets/images/base-widgets/geographic_exposure.png';
import PieChartImage from 'assets/images/base-widgets/pie_chart.png';
import PeerGroupImage from 'assets/images/base-widgets/peer-group.png';
import CustomStackedColumnChartAImage from 'assets/images/base-widgets/long_and_short_exposure.png';
import RadarImg from 'assets/images/base-widgets/radar.png';
import ClusterImg from 'assets/images/base-widgets/cluster-diagram.png';
import ChartAImg from 'assets/images/base-widgets/generic-chart-a.png';
import AnnualLongShort from 'assets/images/base-widgets/long-short-attribution.png'
import TotalAlphaVsPassiveNet from 'assets/images/base-widgets/total-vs-passive.png'
import Exposure from 'assets/images/base-widgets/exposure.png'


export default {
  'bbc43643-3c49-4f8d-a04e-08aff65e5c17': ColChartAImg,
  '13068696-3d50-4e78-9b01-9c967f44feef': StackedColB,
  '4c689137-0c05-46bd-b396-e41ee626ccfb': LineGraphB,
  '1599bff0-fa95-4923-bf30-c4a222ff94d8': ColChartBImg,
  'f941874a-f11a-487f-911e-ae5eddfb8cdc': ColChartBImg,
  'd7b63411-73a6-4a41-a8e1-a61580c95f4a': Performance,
  '9241ccec-9418-4b1f-bfa9-0921d5899790': CustomTableC,
  '6d82a7cc-cade-47c2-bf19-3db3f4fa1840': LineGraphASecondY,
  '9c046b6c-7ece-4679-bf61-46eeaaaf020d': SubStrExposure,
  'bc0816d5-815b-492f-94a9-51556d1cc56a': PortfolioManagers,
  'af8ff7e4-3e18-4d7c-9505-ede24201f861': StrExposure,
  '6cc85b38-2be6-4656-a911-6546b52b7bf8': ScatterImg,
  '653dd0a6-61da-4897-9004-fe518cf19c36': CumulativeImg,
  'f38558a5-e24b-415f-8209-ea06f8e5e9fb': BarChartImage,
  '79a02a29-aceb-443d-a489-e73a701df1aa': LineGraphA,
  '34fc7764-81af-4f9e-a92f-afb9a3adc063': ComparitiveStatsImage,
  'b672de05-1ebe-4ac1-a12d-1596ab14de42': CustomTableD,
  'ef3a8cd8-ab39-4234-a4e6-2a566b136ff0': LineGraphB,
  '249304a5-61f3-43c6-98b5-43b2eec70eb4': DocumentsImage,
  'f487350c-d514-43bb-ac7b-50b90e4c33a6': NotesImage,
  '04f47f95-39f5-4783-a417-a2d70c266883': ColChartAImg,
  '691a3fda-b1c0-43fa-a453-5a237aa7f603': TableAImg,
  '3aa323dd-7250-4d1a-a165-60636f770be2': ObjectMap,
  '486acde5-eb84-4205-a89f-cf497813aa87': ScatterImg,
  '7ea78cd2-1ee0-4a3d-8dc2-564ff41c2771': StrExposure,
  '9dfb2d02-b4d7-48a1-97e1-27c3c9a3f213': CustomTableD,
  'de845955-6281-41f9-864e-a52f7ad7e16f': DiversificationImage,
  'a61f1e3f-e741-4027-93be-51b59e2f43e6': AreaColumnChart,
  'e039af25-79ed-48c6-9ea0-942ae3c4e1c5': PieChartImage,
  '2e5b3366-eb4f-4ae0-b464-e245b281ddb3': AreaColumnChart,
  '6c5ede53-9e6e-44e8-b9e5-9d185f3f368e': PeerGroupImage,
  '66b94e1d-5519-490e-bc69-1ba044b6d0e4': TableAImg,
  'bf7735f5-e1dc-48d9-8ca7-f1a98ff5c505': CustomStackedColumnChartAImage,
  '02c779eb-b714-4922-926a-f1b3db872fd0': RadarImg,
  '315ef7f8-587e-40f8-8ecd-c6bc7df231d4': ClusterImg,
  '1aa16ea2-ee4a-4226-bbfd-743202c75cbf': ChartAImg,
  '7f02d3a4-8940-405d-b0a4-fb40c81136f0': AnnualLongShort,
  'c3ff02d1-512b-45b3-b581-6a94478fb63d': TotalAlphaVsPassiveNet,
  '76775e1a-8133-49c8-8d48-1ddb209aceab': Exposure
};

// {
//   id: 'bbc43643-3c49-4f8d-a04e-08aff65e5c17',
//   name: 'Column Chart A'
// },
// {
//   id: '9241ccec-9418-4b1f-bfa9-0921d5899790',
//   name: 'Custom Table C (Rolling Performance)'
// },
// {
//   id: 'b672de05-1ebe-4ac1-a12d-1596ab14de42',
//   name: 'Custom Table D (Holding Details)'
// },
// {
//   id: '66b94e1d-5519-490e-bc69-1ba044b6d0e4',
//   name: 'Table B (Conditional Format)'
// },
// {
//   id: 'ef3a8cd8-ab39-4234-a4e6-2a566b136ff0',
//   name: 'Line Graph B'
// },
// {
//   id: '6d82a7cc-cade-47c2-bf19-3db3f4fa1840',
//   name: 'Line Graph A (Including second Y axis)'
// },
// {
//   id: '249304a5-61f3-43c6-98b5-43b2eec70eb4',
//   name: 'Documents Access'
// },
// {
//   id: '9c046b6c-7ece-4679-bf61-46eeaaaf020d',
//   name: 'Sub-Strategy Exposure Chart'
// },
// {
//   id: 'f487350c-d514-43bb-ac7b-50b90e4c33a6',
//   name: 'Notes Access'
// },
// {
//   id: 'bc0816d5-815b-492f-94a9-51556d1cc56a',
//   name: 'Custom Table A (Portfolio Managers)'
// },
// {
//   id: 'a61f1e3f-e741-4027-93be-51b59e2f43e6',
//   name: 'Area Column Chart' // Comeback to this
// },
// {
//   id: '7ea78cd2-1ee0-4a3d-8dc2-564ff41c2771',
//   name: 'Strategy Exposure Chart'
// },
// {
//   id: '691a3fda-b1c0-43fa-a453-5a237aa7f603',
//   name: 'Table A'
// },
// {
//   id: '3aa323dd-7250-4d1a-a165-60636f770be2',
//   name: 'Object Map'
// },
// {
//   id: '6cc85b38-2be6-4656-a911-6546b52b7bf8',
//   name: 'Scatter Plot B'
// },
// {
//   id: 'e039af25-79ed-48c6-9ea0-942ae3c4e1c5',
//   name: 'Pie Chart'
// },
// {
//   id: '13068696-3d50-4e78-9b01-9c967f44feef',
//   name: 'Stacked Column Chart B (incl. Line)'
// },
// {
//   id: '6c5ede53-9e6e-44e8-b9e5-9d185f3f368e',
//   name: 'Custom Stacked Column Chart B (Benchmarks)'
// },
// {
//   id: '04f47f95-39f5-4783-a417-a2d70c266883',
//   name: 'Column Chart A'
// },
// {
//   id: 'de845955-6281-41f9-864e-a52f7ad7e16f',
//   name: 'Area Line Chart'
// },
// {
//   id: 'd7b63411-73a6-4a41-a8e1-a61580c95f4a',
//   name: 'Performance'
// },
// {
//   id: 'f941874a-f11a-487f-911e-ae5eddfb8cdc',
//   name: 'Column Chart B (incl. Line)'
// },
// {
//   id: '34fc7764-81af-4f9e-a92f-afb9a3adc063',
//   name: 'Custom Table B (Comparative Stats)'
// },
// {
//   id: '1599bff0-fa95-4923-bf30-c4a222ff94d8',
//   name: 'Column Chart B (incl. Line)'
// },
// {
//   id: '486acde5-eb84-4205-a89f-cf497813aa87',
//   name: 'Scatter Plot A'
// },
// {
//   id: '2e5b3366-eb4f-4ae0-b464-e245b281ddb3',
//   name: 'Stacked Column Chart C (Area Map)'
// },
// {
//   id: '4c689137-0c05-46bd-b396-e41ee626ccfb',
//   name: 'Line Graph B (incl. STDV)'
// },
// {
//   id: '79a02a29-aceb-443d-a489-e73a701df1aa',
//   name: 'Line Graph A'
// },
// {
//   id: 'f38558a5-e24b-415f-8209-ea06f8e5e9fb',
//   name: 'Bar Chart'
// },
// {
//   id: '32f79222-fb91-478d-8973-ed2c6cfe99fc',
//   name: 'Heat Map'
// },
// {
//   id: 'af8ff7e4-3e18-4d7c-9505-ede24201f861',
//   name: 'Stacked Column Chart A'
// },
// {
//   id: 'bf7735f5-e1dc-48d9-8ca7-f1a98ff5c505',
//   name: 'Custom Stacked Column Chart A (Exposure)'
// },
// {
//   id: '02c779eb-b714-4922-926a-f1b3db872fd0',
//   name: 'Radar Chart'
// },
// {
//   id: '653dd0a6-61da-4897-9004-fe518cf19c36',
//   name: 'Line Graph C (incl. Area)'
// }
